import { List, ListItem, Typography } from "@mui/material";
import { useEffect, useState } from "react"

export { SelectedEmailsViewer }

function SelectedEmailsViewer({emails}) {

    const [ selectedEmails, setSelectedEmails ] = useState(null);

    useEffect(() => {
        if (emails) {
            setSelectedEmails(emails)
        }            
    }, [emails])

    return(
        <>
            {selectedEmails ? (
                <div className="selected-emails">
                    {selectedEmails.dealer && 
                    <div className="w-full mb-4">
                        <Typography variant="h6">Emails sélectionnés</Typography>                            
                    </div>}
                    <Typography variant="subtitle1">Concessionnaire: {selectedEmails.dealer}</Typography>
                    <div className={`grid grid-cols-3 gap-4`}>
                        {/* Colonne des Clients */}
                        {selectedEmails.clientEmails.length > 0 && (
                            <List className="bg-gray-100 p-4 rounded-lg">
                                <Typography variant="subtitle1">Clients :</Typography>                                    
                                    {selectedEmails.clientEmails.map((email, index) => (
                                        <ListItem key={index} className="text-gray-700">{email}</ListItem>
                                    ))}
                            </List>
                        )}

                        {/* Colonne des Techniciens */}
                        {selectedEmails.techEmails.length > 0 && (
                            <List className="bg-gray-100 p-4 rounded-lg">
                                <Typography variant="subtitle1">Techniciens (SZM) :</Typography>
                                    {selectedEmails.techEmails.map((email, index) => (
                                        <ListItem key={index} className="text-gray-700">{email}</ListItem>
                                    ))}
                            </List>
                        )}

                        {/* Colonne des Emails du textarea */}
                        {selectedEmails.otherEmails.length > 0 && (
                            <List className="bg-gray-100 p-4 rounded-lg">
                                <Typography variant="subtitle1">Emails ajoutés manuellement :</Typography>
                                    {selectedEmails.otherEmails.map((email, index) => (
                                        <ListItem key={index} className="text-gray-700">{email}</ListItem>
                                    ))}
                            </List>
                        )}
                    </div>                        
                </div>
            ):(
                <div>Aucun email sélectionné</div>
            )}
        </>
    )
}